import type { RootState } from 'redux/store';
import { createSelector } from 'reselect';

const selectPropertyState = (state: RootState) => state.property;

export const selectProperty = createSelector(
	selectPropertyState,
	(property) => property,
);
